/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import AddM from "../../assets/image/AddM.svg";
import Minus from "../../assets/image/Minus.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import DeleteConfirmModal from "./DeleteConfirmModal";
import FormLayout from "./FormLayout";
import InputField from "./InputField";
import LoadingButton from "./LoadingButton";
export const AddRecipient = () => {
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
    setError,
    clearErrors,
    reset,
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      machines: [],
      MachineID: "",
    },
  });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "machines",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [is_active, setIsActive] = useState(true);
  const [filtered, setFiltered] = useState([]);
  const [load, setLoad] = useState(false);
  const { ClearFormSet, machineList, singleRecipinet } = useSelector(
    (state) => state.adminReducers
  );
  const { websocket } = useContext(WebSocketContext);

  // const [selectedMachines, setSelectedMachines] = useState([]);
  const [loading, setLoading] = useState({id: "",});
  const [removeModal, setRemoveModal] = useState({open: false,machine: null,});

  useEffect(() => {
    if (params?.id) {
      const payload = {
        transmit: "single",
        url: "recipient_get",
        request: { recipient_id: params?.id },
      };
      wsSend_request(websocket, payload);
    }
  }, [params?.id]);
  const onSubmit = (data) => {
    const machineIds = fields?.map((machine) => machine?.for_api_id);
    const machineName = data?.machines?.map((machine) => machine?.machineName);

    if (!machineIds || machineIds?.length === 0) {
      setError("MachineID", {
        type: "manual",
        message: "Please map at least one machine to this recipient",
      });
      return;
    } else {
      clearErrors("MachineID");
    }
    setLoad(true);
    const payload = {
      transmit: "single",
      url: params?.id ? "recipient_update" : "recipient_add",
      request: {
        recipient_account_name: data.accountName,
        recipient_name: data.recipientName,
        email: data.email,
        recipient_machine_name: machineName,
        is_active: is_active,
        machine: machineIds,
        machine_list_with_recipient: data?.machines,
        ...(params?.id && { recipient_id: params?.id }),
        ...(watch('password') && { password: data.password }),
      },
    };
    wsSend_request(websocket, payload);
  };
  useEffect(() => {
    if (
      (ClearFormSet?.url === "recipient_add" ||
        ClearFormSet?.url === "recipient_update") &&
      ClearFormSet?.action === 200
    ) {
      navigate("/recipient-management");
      setLoad(false);
    } else {
      setLoad(false);
    }
    if (ClearFormSet?.url) {
      const timeout = setTimeout(() => {
        dispatch(
          ClearFormSetFutios({
            url: "",
            action: "",
          })
        );
      }, 1000);

      return () => clearTimeout(timeout);
    }
  }, [ClearFormSet, dispatch, navigate]);

  const handleAdd = (machine) => {
    setLoading({ id: machine?.id });
    setTimeout(() => {
      setLoading({ id: "" });
    }, 300);
    const currentDocuments = getValues("machines") || [];
    const alreadyAdded = currentDocuments?.find(
      (item) => item?.machineID === machine.code
    );
    if (alreadyAdded) {
      toast.error(`${machine?.name} is already added!`);
    } else {
      append({
        machineName: "",
        machineID: machine.code,
        for_api_id: machine?.id,
      });
      toast.success(`${machine?.name} added successfully!`);
      setValue("MachineID", "");
    }
  };
  const handleRemove = (machine) => {
    setRemoveModal({ open: true, machine });
  };

  const searchValue = watch("MachineID");
  useEffect(() => {
    if (searchValue?.length > 0) {
      const payload = {
        transmit: "single",
        url: "machine_list",
        request: {
          status: true,
          limit: "20",
          page_no: "1",
          search: "",
          machine_search: searchValue,
          order_by: "-updated_at",
        },
      };
      wsSend_request(websocket, payload);
    } else {
      setFiltered([]);
    }
  }, [searchValue]);
  useEffect(() => {
    if (searchValue?.length > 0) {
      const machineListForFilter = machineList?.list
        ?.filter((item) => item?.id && item?.machine_name && item?.machine_code)
        ?.map((item) => ({
          id: item?.id,
          name: item?.machine_name,
          code: item?.machine_code,
        }));

      setFiltered(machineListForFilter);
    }
  }, [machineList]);

  const closeRemoveModal = () => {
    setRemoveModal({ open: false, machine: null });
  };

  const confirmRemove = () => {
    const machine = removeModal.machine;
    setLoading({ id: machine?.for_api_id });
    const indexToRemove = fields.findIndex(
      (item) => item.for_api_id === machine?.for_api_id
    );
    const payload = {
      transmit: "single",
      url: "machine_delete",
      request: { id: machine?.for_api_id },
    };
    setTimeout(() => {
      wsSend_request(websocket, payload);
      if (indexToRemove !== -1) {
        remove(indexToRemove);
      }

      setLoading({ id: "" });
      setRemoveModal({ open: false, machine: null });
    }, 300);
  };
  useEffect(() => {
    if (params?.id) {
      setIsActive(singleRecipinet?.is_active);
      reset({
        accountName: singleRecipinet?.recipient_account_name,
        recipientName: singleRecipinet?.username,
        email: singleRecipinet?.email,
        machineName: singleRecipinet?.recipient_machine_name,
        password: singleRecipinet?.view_password,
      });
      replace(singleRecipinet?.machine_list_with_recipient);
    }
  }, [singleRecipinet]);
  return (
    <>
      <FormLayout title={params?.id ? "Update Recipient" : "Add New Recipient"}>
        <form onSubmit={handleSubmit(onSubmit)} className="container">
          <div className="row">
            <div className="col-md-5">
              <InputField
                label="Recipient Login Id"
                name="accountName"
                register={register}
                required
                errors={errors}
                placeholder="Enter Recipient Login Id"
              />
            </div>
            <div className="col-md-5 ">
              <InputField
                label="Recipient Name"
                name="recipientName"
                register={register}
                required
                errors={errors}
                placeholder="Enter Recipient Name"
              />
            </div>
          </div>
          <div className="col-10">
            <InputField
              label="Recipient Email"
              name="email"
              register={register}
              required
              errors={errors}
              type="email"
              placeholder="Enter Recipient Email"
            />
          </div>
          <div className="row">
            <div className="col-md-5" style={{ position: "relative" }}>
              <InputField
                label="Machine ID"
                name="MachineID"
                register={register}
                required={false}
                errors={errors}
                placeholder="Search Machine by ID"
                isSearchIcon={true}
                isStar={true}
              />

              <div className="search-machine">
                {filtered?.length > 0 && (
                  <div className="result-list new_add_box">
                    {filtered?.map((machine, index) => (
                      <div
                        key={machine?.id}
                        className="result-card d-flex justify-content-between align-items-center p-2 mb-2"
                        style={{
                          borderBottom:
                            index !== filtered?.length - 1
                              ? "1px solid #ECECEC"
                              : "none",
                          background: "white",
                        }}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="bg-success-subtle rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                              width: 40,
                              height: 40,
                              background: "#DCEDE4",
                              borderRadius: "50px",
                            }}
                          >
                            <img src={AddM} alt="Add Machine" />
                          </div>
                          <div>
                            <div className="fw-bold">{machine?.name}</div>
                            <div className="text-muted small">
                              {machine?.code}
                            </div>
                          </div>
                        </div>
                        <div
                          className="btn  btn-sm"
                          style={{ background: "#B6EFBB", fontWeight: "bold" }}
                          onClick={() => handleAdd(machine)}
                        >
                          {loading?.id === machine?.id ? "Adding" : "+ Add"}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          {fields?.map((item, index) => (
            <div className="row" key={item.id}>
              <div className="col-md-5">
                <InputField
                  label="Recipient Machine Name"
                  name={`machines.${index}.machineName`}
                  placeholder="Enter Machine Name"
                  register={register}
                  errors={errors}
                  required={true}
                  isNewError={true}
                />
              </div>

              <div className="col-md-5">
                <InputField
                  label="Machine ID"
                  placeholder="Machine Code"
                  name={`machines.${index}.machineID`}
                  register={register}
                  defaultValue={item.machineID}
                  errors={errors}
                  disabled={true}
                  required={true}
                />
              </div>

              <div className="col-md-1 d-flex align-items-center m-1">
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{
                    background: "#F7ABAB",
                    color: "black",
                    border: "none",
                    height: "40px",
                    width: "40px",
                  }}
                  onClick={() => handleRemove(item, index)}
                >
                  <img
                    src={Minus}
                    alt="Remove"
                    title="Remove"
                    className="w-100"
                  />
                </button>
              </div>
            </div>
          ))}

          <div className="row">
            <div className="col-5">
              <InputField
                label="Password"
                name="password"
                register={register}
                required={params?.id ? false : true}
                errors={params?.id ? "" : errors}
                type={"password"}
                placeholder="Enter Password"
                // disabled={params?.id}
                isPassword={true}
              />
              <div className="d-flex gap-2">
                <Form.Check
                  type="switch"
                  id={`switch-id-for-status`}
                  checked={is_active}
                  className=""
                  onChange={(e) => setIsActive(e.target.checked)}
                />
                <span className="new_status_class label_class_name_for_input">
                  Status
                </span>
              </div>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-12 d-flex gap-2 mt-3">
              <LoadingButton
                loading={load}
                text={params?.id ? "Save" : "Save"}
              />
            </div>
          </div>
        </form>
      </FormLayout>
      {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to Remove this Machine ID?"
        />
      )}
    </>
  );
};
export default AddRecipient;
